import API_ENDPOINT from '../globals/api-endpoint';

class RestaurantSource {
  static async getAllResto() {
    const response = await fetch(API_ENDPOINT.LIST);
    const responseJson = await response.json();
    return responseJson.restaurants;
  }

  static async detailResto(id) {
    const response = await fetch(API_ENDPOINT.DETAIL(id));
    return response.json();
  }

  static async postReview(formData) {
    const response = await fetch(API_ENDPOINT.REVIEW, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    });
    if (response.status !== 201) {
      throw new Error('Gagal menambah review');
    } else {
      // eslint-disable-next-line no-undef
      Swal.fire({
        title: 'Gagal!',
        text: 'Gagal menambahkan review',
        icon: 'error',
        confirmButtonText: 'OK',
        allowOutsideClick: false,
      });
      return response;
    }
  }
}

export default RestaurantSource;
